"use client";
import { LinkTrackers } from "~/components/reusables/link-trackers";
import { usePathname } from "next/navigation";

interface SubmenuItem {
  url: string;
  internal?: boolean;
  title: string;
  text: string;
}

interface Submenu {
  title: string;
}

interface FooterSubmenuLinkProps {
  submenuItem: SubmenuItem;
  submenu: Submenu;
  className?: string;
}

const FooterSubmenuLink: React.FC<FooterSubmenuLinkProps> = ({
  submenuItem,
  submenu,
  className = "text-[16px] text-primary-gray hover:text-white hover:underline",
}) => {
  const pathname = usePathname();
  const showAltContact =
    (pathname.includes("/quantum-random-number-generator") ||
      pathname.includes("/quantum")) &&
    submenuItem.text === "Contact Us";

  const isTheShift = submenuItem.text === "The Shift";
  const isAppsAndServices = submenu.title === "Apps & Services";

  const segmentMsg = isTheShift
    ? "Outshift newsletters clicked"
    : "Link clicked";

  const segmentOpt = isTheShift
    ? {
        link_label: "The Shift",
        location: "Navigation bar - footer",
        location_detail: "About us - company",
        resource_interaction: "view newsletter subscription form",
      }
    : isAppsAndServices
      ? {
          link_label: submenuItem.title,
          location: "footer",
          resource_interaction: "visit each app/service page",
        }
      : {
          link_label: submenuItem.title,
          location: "footer",
        };

  return (
    <LinkTrackers
      href={
        showAltContact ? "mailto:quantumlabs@cisco.com" : submenuItem.url
      }
      target={submenuItem.internal ? (showAltContact ? "_blank" : "_self") : "_blank"}
      segmentMsg={segmentMsg}
      segmentOpt={segmentOpt}
      className={className}
    >
      {submenuItem.text}
    </LinkTrackers>
  );
};

export default FooterSubmenuLink;
